export enum CaptchaAction {
  NEWSLETTER_SUBSCRIBE = 'newsletter_subscribe',
  APR_COUNTDOWN_SUBSCRIBE = 'apr_notify_me',
  APR_PASSWORD = 'apr_password',
}
